L<template>
  <svg class="SVG-Cross-Thin-Icon" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
    <path class="SVG-Cross-Thin-Icon__stroke" d="M13 1L1 13M13 13L1 1" stroke="var(--gray-400)" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>